// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"04a7b267","353":"364c0cf1"}[chunkId] + ".chunk.css";
};